import { DefaultLoaderProps } from './types';

const MAPPING: Record<string, string> = {
  small: '/grnld-r200/',
  medium: '/grnld-r600/',
  large: '/xxl/',
};

function defaultLoader({ src, suffix }: DefaultLoaderProps) {
  let source = src;

  //add suffix if exists
  /* if (suffix) {
    const lastDotIndex = src.lastIndexOf('.');

    source = `${source.substring(0, lastDotIndex)}-${suffix}.${source.substring(lastDotIndex + 1)}`;
  } */
  if (suffix && MAPPING[suffix]) {
    source = source.replace('/original/', MAPPING[suffix]);
  } else {
    source = source.replace('/original/', '/grnld-r900/');
  }

  return source;
}

export default defaultLoader;
